module.exports = __webpack_public_path__ + "img/Approved-Logo.07637f13.svg";